import api from './api';

// Serviços específicos para produtos
export const productService = {
    // Buscar lista de produtos públicos
    async getPublicProducts() {
        try {
            const response = await api.get('products/public/list');
            return response.data?.products || response.products || [];
        } catch (error) {
            console.error('Erro ao buscar produtos:', error);
            return null;
        }
    },

    // Buscar produto por ID
    async getProductById(id) {
        try {
            const response = await api.get(`products/public/${id}`);
            return response;
        } catch (error) {
            console.error('Erro ao buscar produto:', error);
            throw error;
        }
    },

    // Formatar produto da API para o formato usado no frontend
    formatProductForFrontend(apiProduct) {
        // A API agora retorna o produto diretamente em response.data
        const productData = apiProduct.data || apiProduct;
        
        return {
            id: productData.id, // Usar o ID completo da API
            title: productData.name || 'Produto sem nome',
            description: productData.description || 'Produto sem descrição',
            image: productData.image || '/images/banner-chess.jpg', // Imagem padrão
            alt: productData.name || 'Produto sem nome',
            originalPrice: null,
            currentPrice: productData.base_price / 100, // Converte centavos para reais
            sku: productData.sku,
            stock: productData.stock_quantity,
            isReadyToShip: productData.availability?.is_ready_to_ship || false,
            leadTime: productData.availability?.lead_time_for_order || 0,
            isCustomizable: productData.is_customizable || false,
            assemblyRequired: productData.assembly_required || false,
            measures: productData.measures || {},
            category: productData.category,
            materials: productData.materials,
            mechanicalProperties: productData.mechanical_properties,
            application: productData.application,
            warrantyDetails: productData.warranty_details,
            dimensionalTolerance: productData.dimensional_tolerance,
            features: [] // Array vazio como fallback
        };
    },

    // Formatar múltiplos produtos
    formatProductsForFrontend(apiProducts) {
        return apiProducts.map(product => this.formatProductForFrontend(product));
    }
};

export default productService;
